import React, { useEffect, useState } from 'react'
import { useSearchConditionPc } from '../hooks/useSearchCondition'
import { GoodsItem, serviceGoodsList, serviceStaffs } from '../services/common/filter'
import { LabeledValue, SelectProps } from 'antd/es/select';
import { isError } from '@/component/common/error';
import { useGetData } from '@/component/PageComponent/hooks/requst';
import { useSelectRow } from '@/component/PageComponent/Table/hooks/columns';
import { DhbFilterForm, DhbFooterProps } from '@/component/PageComponent/PageComponent';
import { TableResize } from '@/component/PageComponent/Table/TableResize';
import { Button, Col, Pagination, Row, Flex } from 'antd';
import { SelectModalPc } from '../Common/SelectModalPc';

type FilterParams = Partial<{
    page: number;
    pageSize: number;
    isCustomize: true;
}>;

const DhbFooter = (
    props: DhbFooterProps & { onCancel(): void; onOk(): void },
) => {
    const {
        selectedRowKeys = [],
        onChange,
        total = 0,
        pageInfo,
        toggleSelectRowKeys,
    } = props;
    const { page = 1, pageSize = 10 } = pageInfo;

    return (
        <div style={{ padding: '10px' }}>
            <Row>
                <Col span={14}>
                    <Pagination
                        style={{ textAlign: 'left' }}
                        defaultPageSize={pageSize}
                        total={total}
                        current={page}
                        onChange={(page, pageSize) => onChange({ page: page, pageSize })}
                        onShowSizeChange={(current, pageSize) =>
                            onChange({ page: 1, pageSize })
                        }
                        showQuickJumper={false}
                    />
                </Col>
                <Col span={10}>
                    <div style={{ textAlign: 'right' }}>
                        <Button
                            onClick={() => props.onCancel()}
                            style={{ margin: '0 10px' }}
                        >
                            取消
                        </Button>
                        <Button type="primary" onClick={() => props.onOk()}>
                            确定
                        </Button>
                    </div>
                </Col>
            </Row>
        </div>
    );
};

const columns = [
    {
        width: 50,
        dataIndex: 'key',
        render: (text: string, record: GoodsItem, index: number) => {
            return index + 1;
        }
    },
    {
        // width: '15%',
        title: '联营商',
        dataIndex: 'label'
    }
];


const listKey:'key' = 'key';
interface StaffListModalProps {
    onChangeValues: SelectProps['onChange'];
    onClose(): void;
    type: 'radio' | 'checkbox';
    list: LabeledValue[];
}

const chunkArray=(array:LabeledValue[], size:number)=> {
    const chunkedArray = [];
    for (let i = 0; i < array.length; i += size) {
      chunkedArray.push(array.slice(i, i + size));
    }
    return chunkedArray;
}

const CollaboratorListModal = (props: StaffListModalProps) => {
    const [pageInfo,setPageInfo] = React.useState({page:1, pageSize:10})
    const collaborList = chunkArray(props.list,10)
    const [pageList,setPageList] = React.useState(collaborList[0])

    const { selectedRowKeys, isAllSelect, toggleSelectRowKeys, setSelectedRowKeys, } = useSelectRow(props.list, listKey);
    React.useEffect(() => {
        // getStaffs({ ...params, ...pageInfo });
    }, []);
    return (
        <Flex vertical style={{ height: '100%' }}>
            <h2 style={{ paddingLeft: '16px',margin:'16px 0 0 0' }}>选择联营商</h2>
            {/* <DhbFilterForm
                defaultParams={initParams}
                loading={loading}
                onSearch={(params) => setParams(params)}
                filterProps={{
                    filters: [
                        // {
                        //     type: 'Input',
                        //     title: '名称/首字母拼音/编号',
                        //     dataIndex: 'kw',
                        //     placeholder: '名称/首字母拼音/编号',
                        //     width: '40%',
                        // },

                    ],
                }}
            /> */}
            
            <TableResize
                style={{ flex: 1, padding: '16px 20px 16px 16px' }}
                rowKey={listKey}
                pagination={false}
                columns={columns}
                dataSource={pageList}
                rowSelection={{
                    type: props.type,
                    selectedRowKeys: selectedRowKeys,
                    onChange: (keys) => {
                        setSelectedRowKeys(keys as any);
                    },
                }}
                size="middle"
            />
            <DhbFooter
                selectedRowKeys={selectedRowKeys}
                dataSource={props.list}
                isAllSelect={isAllSelect}
                toggleSelectRowKeys={toggleSelectRowKeys}
                onChange={(pageInfo) => {
                    setPageInfo(pageInfo);
                    setPageList(collaborList[pageInfo.page-1])
                }}
                total={props.list.length}
                pageInfo={pageInfo}
                onCancel={() => {
                    props.onClose();
                }}
                onOk={() => {
                    props.onClose();
                    let selectedRow: LabeledValue[] = [];
                    props.list.forEach((item:LabeledValue) => {
                        
                        if (selectedRowKeys.includes(item[listKey] as string)) {
                            selectedRow.push(item);
                        }
                    });
                    console.log(selectedRowKeys, selectedRow[0],"item");

                    props.onChangeValues &&
                        props.onChangeValues(selectedRowKeys, selectedRow);
                }}
            />
        </Flex>
    );
};

export interface FilterCollaboratorPcProps extends SelectProps {
}

function FilterCollaboratorPc(props: FilterCollaboratorPcProps) {
    const { placeholder = '选择联营商', value, mode = 'multiple', ...rest } = props
    const { searchCondition, loading, getInitData } = useSearchConditionPc({ collaborator: ['list'] })
    // const [values, setValues] = useState<string | string[]>(value)
    let onChange: SelectProps['onChange'] = (value, option) => {
        props.onChange && props.onChange(value, option)
    };
    return (
        <div>
            <SelectModalPc
                mode={mode}
                placeholder={placeholder}
                options={searchCondition.collaborator?.list}
                value={value}
                loading={loading}
                getInitData={getInitData}
                onChange={(value, option) => {
                    onChange && onChange(value, option);
                }}
                MoreComponent={({ onClose }) => (
                    <CollaboratorListModal
                        list={searchCondition.collaborator?.list || []}
                        type={mode == 'multiple' ? 'checkbox' : 'radio'}
                        onClose={onClose}
                        onChangeValues={onChange}
                    />
                )}
                {...rest}
            />
        </div>
    )
}

export default FilterCollaboratorPc